/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import {
  FormControl, InputLabel, makeStyles, MenuItem, Select,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { PageWrapper, TableWrapper } from "../../../../shared/layout";
import NavFilter from "../../../../shared/widgets/navFilter/navFilter";
import { selectedCity as selectedCityAction } from "../../../../redux/actions/citiesAction";
import { RangePicker } from "../../../../shared/widgets";
import {
  fetchReportNamesAction, fetchUserGeneratedReportsAction,
  generateReportAction, getLinkAndDownloadReportAction,
} from "../../../../redux/action-creators/reportsModuleActionCreator";
import { templateStrings } from "../../../../Constant";

const useStyles = makeStyles(() => ({
  dropdownContainer: {
    margin: "0 12vw",
  },
  selectContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  dropdownLabel: {
    color: "black",
    fontSize: "16px",
    fontWeight: "600",
    width: "200px",
  },
  datePickerLabel: {
    color: "black",
    fontSize: "16px",
    fontWeight: "600",
    width: "200px",
  },
  selectCityDropdown: {
    backgroundColor: "grey",
    width: "16vw",
    minWidth: "165px",
    maxWidth: "300px",
    maxHeight: "70px",
    borderRadius: "7px",
  },
  selectReportDropdown: {
    width: "16vw",
    minWidth: "165px",
    maxWidth: "300px",
  },
  selectDurationDropdown: {
    width: "15.7vw",
    minWidth: "165px",
    margin: "2vh 0 0 0",
    maxWidth: "300px",

  },
  dateRangePicker: {
    width: "17vw",
    minWidth: "165px",
    margin: "2vh 0 0 0",
    textAlign: "center",
    maxWidth: "300px",

  },
  dateRangePickerToolbar: {
    marginLeft: "0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
  },
  generateReportBtn: {
    width: "15.7vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f47c21",
    color: "#fff",
    "&:hover, &:focus": {
      color: "#fff",
    },
  },
  generateReportContainer: {
    display: "flex",
    justifyContent: "end",
    margin: "1vw 0 0 0",
  },

  "@media (max-width:768px)": {
    dropdownContainer: {
      margin: "0 0",
    },
    selectContainer: {
      flexDirection: "column",
    },
    dropdownLabel: {
      margin: "2vh",
      width: "auto",
    },
    datePickerLabel: {
      margin: "2vh",
    },
    selectCityDropdown: {
      width: "60vw",
    },
    selectReportDropdown: {
      width: "60vw",
    },
    selectDurationDropdown: {
      width: "59.7vw",
    },
    dateRangePicker: {
      width: "60vw",
    },
    dateRangePickerToolbar: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    generateReportBtn: {
      width: "39.7vw",
      margin: "2vh 0 0 0",
    },
    generateReportContainer: {
      justifyContent: "center",
    },
  },
}));

export const reportTypesEnum = {
  distance: "Distance",
  mobileTickets: "Mobile Tickets",
};

const handleNotCustomSelected = (event, setIsCustomDate) => {
  event.target.value !== "Custom" && setIsCustomDate(false);
};

const handleGeneratedReportsInterval = (
  GeneratedReports,
  interval,
  dispatch,
  pageNo,
  rowsPerPage,
) => {
  if (GeneratedReports?.totalReports) {
    let stop = true;
    GeneratedReports?.generatedReports.forEach((report) => {
      if (report.status === "inProgress" || report.status === "queued") {
        stop = false;
      }
    });
    if (stop) {
      clearInterval(interval.current);
    } else {
      clearInterval(interval.current);
      // eslint-disable-next-line no-param-reassign
      interval.current = setInterval(() => {
        dispatch(fetchUserGeneratedReportsAction({ pageNo, pageSize: rowsPerPage }));
      }, 7000);
    }
  }
};

const updateDateRange = (dates, setDateRange) => {
  if (dates.startDate && dates.endDate) {
    const fromDate = parseFloat(new Date(dates.startDate).getTime());
    const toDate = parseFloat(new Date(dates.endDate).getTime());
    setDateRange({ fromDate, toDate });
  }
};

function ReportsModule(props) {
  const classes = useStyles();

  const calculatePastTimeStamp = (pastDate, numberOfDays) => {
    const date = new Date(pastDate.getTime());
    numberOfDays && date.setDate(date.getDate() - numberOfDays);
    date.setHours(12, 0, 0, 0);
    return date.getTime();
  };

  const [selectedReportType, setSelectedReportType] = useState("");
  const [selectedGeneratedReport, setSelectedGeneratedReport] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("Custom");
  const [selectCityList, setSelectCityList] = useState([]);
  const [cityHeader, setCityHeader] = useState("All Cities");
  const [isCustomDate, setIsCustomDate] = useState(true);
  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateRange, setDateRange] = useState({});

  const reportTypes = useSelector((state) => state.GenerateReports.reportTypes);
  const cities = useSelector((state) => state.Cities.cities);
  const headerLoader = useSelector((state) => state && state.loadingBar && state.loadingBar.header);
  const GeneratedReports = useSelector((state) => state.GenerateReports);

  const templateString = templateStrings.reportsModule;

  const dispatch = useDispatch();

  const interval = useRef();
  useEffect(() => {
    handleGeneratedReportsInterval(
      GeneratedReports,
      interval,
      dispatch,
      pageNo,
      rowsPerPage,
    );
    return () => {
      clearInterval(interval.current);
    };
  }, [GeneratedReports]);

  useEffect(() => {
    dispatch(fetchReportNamesAction());
    dispatch(fetchUserGeneratedReportsAction({
      pageNo,
      pageSize: rowsPerPage,
    })); // dispatch this after clicking on generate reports as well.
  }, [dispatch, pageNo, rowsPerPage]);

  const handleChange = (input, value) => {
    if (input === "pageNo") {
      setPageNo(value);
    } else if (input === "rowsPerPage") {
      setRowsPerPage(value);
    }
  };

  const handleCustomSelection = () => {
    setIsCustomDate(true);
    setDateRange({});
  };

  const handleSelectedPeriodChangeObject = {
    Today: () => setDateRange({
      fromDate: calculatePastTimeStamp(new Date(), 0),
      toDate: calculatePastTimeStamp(new Date(), 0),
    }),
    Yesterday: () => setDateRange({
      fromDate: calculatePastTimeStamp(new Date(), 1),
      toDate: calculatePastTimeStamp(new Date(), 1),
    }),
    "Last 7 Days": () => setDateRange({
      fromDate: calculatePastTimeStamp(new Date(), 6),
      toDate: calculatePastTimeStamp(new Date(), 0),
    }),
    "Last 15 Days": () => setDateRange({
      fromDate: calculatePastTimeStamp(new Date(), 14),
      toDate: calculatePastTimeStamp(new Date(), 0),
    }),
    Custom: () => handleCustomSelection(),
  };

  const handleSelectedPeriodChange = (input, type, objProp) => (event) => {
    setSelectedPeriod(event?.target?.value);
    handleSelectedPeriodChangeObject[event.target.value]();
    handleNotCustomSelected(event, setIsCustomDate);
  };

  const handleSelectedReportTypeChange = (input, type, objProp) => (event) => {
    setSelectedReportType(event?.target?.value);
  };
  const handleCitySelection = async (selectedCityId) => {
    selectedCityAction(selectedCityId);
  };

  const handleAction = (reportDetails) => {
    dispatch(getLinkAndDownloadReportAction(reportDetails.storageKey));
  };

  const setSelected = (source, data) => {
    source === "city" && setSelectCityList(data);
  };

  const setHeader = (source, header) => {
    source === "city" && setCityHeader(header);
  };

  const handleDatesChange = (dates) => {
    updateDateRange(dates, setDateRange);
  };

  const generateReport = () => {
    dispatch(generateReportAction(
      selectCityList,
      selectedReportType,
      dateRange.fromDate,
      dateRange.toDate,
      pageNo,
      rowsPerPage,
    ));
  };

  return (
    // <div className='pageContainer'>
    <PageWrapper>
      <PageWrapper.Header heading="Reports" hideS isHeaderFixed={false} removeFilterOnly hideDivider hideLower />
      <PageWrapper.Body style={{ backgroundColor: "white", marginTop: 0, padding: "20px 0" }}>
        <div className={classes.dropdownContainer}>
          <div className={classes.selectContainer}>
            <InputLabel className={classes.dropdownLabel}>Select City</InputLabel>
            <div className={classes.selectCityDropdown}>
              <NavFilter
                source="city"
                uniqId="uniqId"
                options={cities}
                onMenuSelection={handleCitySelection}
                selected={selectCityList}
                setSelected={setSelected}
                setHeader={setHeader}
                filterHeader={cityHeader || "All Cities"}
              />
            </div>
          </div>
          <div className={classes.selectContainer}>
            <InputLabel className={classes.dropdownLabel}>Select Report Type</InputLabel>
            <div className={classes.selectReportDropdown}>
              {/* <Grid item xs={6} className="selectWrapper"> */}
              <FormControl className="settlementFieldWrapper">
                <InputLabel
                  id="demo-simple-select-label"
                  required
                  className={classes.dropdownHeader}
                >
                  Select Report Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedReportType}
                  onChange={handleSelectedReportTypeChange("selectedReportType", "event")}
                  className={classes.selectPeriodDropdown}
                >
                  {reportTypes && Object.keys(reportTypes).map((key, index) => (
                    <MenuItem key={key} value={`${key}`}>{reportTypes[key]}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* </Grid> */}
            </div>
          </div>
          {/* <div className={classes.dateRangeContainer}> */}
          <div className={classes.selectContainer}>
            <InputLabel className={classes.dropdownLabel}>Select Duration</InputLabel>
            <div className={classes.selectDurationDropdown}>
              {/* <Grid item xs={6} className="selectWrapper"> */}
              <FormControl className="settlementFieldWrapper">
                <InputLabel
                  id="demo-simple-select-label"
                  required
                  className={classes.dropdownHeader}
                >
                  Select Duration
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedPeriod}
                  onChange={handleSelectedPeriodChange("selectedPeriod", "event")}
                  className={classes.selectPeriodDropdown}
                >
                  <MenuItem value="Today">Today</MenuItem>
                  <MenuItem value="Yesterday">Yesterday</MenuItem>
                  <MenuItem value="Last 7 Days">Last 7 Days</MenuItem>
                  <MenuItem value="Last 15 Days">Last 15 Days</MenuItem>
                  <MenuItem value="Custom">Custom</MenuItem>
                </Select>
              </FormControl>
              {/* </Grid> */}
            </div>
          </div>
          <div>
            {isCustomDate
                  && (
                    <div className={classes.dateRangePickerToolbar}>
                      <InputLabel className={classes.datePickerLabel}>
                        Select Custom Duration
                      </InputLabel>
                      <div className={classes.dateRangePicker}>
                        <RangePicker
                          monthsToDisplay={1}
                          onDatesChange={handleDatesChange}
                          rangeLimit={31}
                        />
                      </div>
                    </div>
                  )}
          </div>
          {/* </div> */}
          <div className={classes.generateReportContainer}>
            <Button
              className={classes.generateReportBtn}
              data-testid="download-report"
              onClick={generateReport}
              variant="Secondary"
              disabled={!selectedReportType || Object.keys(dateRange).length === 0}
            >
              Generate Report
            </Button>
          </div>
        </div>
      </PageWrapper.Body>
      <div>
        <PageWrapper.Header heading="Recent Reports" hideS isHeaderFixed={false} removeFilterOnly hideDivider hideLower />
        <TableWrapper
          content={!headerLoader && GeneratedReports.generatedReports}
          selected={selectedGeneratedReport}
          pageNo={pageNo}
          uniqueKey="_id"
          rowsPerPage={rowsPerPage}
          count={GeneratedReports.totalReports || 0}
          handleChange={handleChange}
          templateString={templateString}
          selectionAllowed={false}
          actionName="Download"
          handleAction={handleAction}
          // onSortToggle={onSortToggle}
          // sortBy={sortBy}
          tableContainerClassName="reports-table"
        />
      </div>
    </PageWrapper>
    // </div>
  );
}

export default ReportsModule;
